<template>
    <div v-if="paymentInfoLabel" class="py-0 cb-4-x-pxf-mention" :class="{'small': !isFromMobileDetail}">
        <strong><span :class="{'d-block': !isFromMobileDetail}" v-html="paymentInfoLabel" /></strong>
        <div class="row">
            <div v-if="paymentInfoDetail" class="col-auto text-gray3 small" v-html="paymentInfoDetail" />
            <div v-if="linkLabel" class="col-auto pt-0 small">
                <ob1-liens-icone
                    icon="icon-info-alt font-size-24"
                    :is-button="true"
                    :title="linkLabel"
                    :modal-id="modalId"
                    :mini="true"
                    data-oevent-category="popin_financement"
                    data-oevent-action="voir_nos_solutions_de_financement"
                    data-oevent-label="vers_popin"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Cb4xPxfMention",
    props: {
        paymentInfoLabel: {
            type: String,
            required: false,
            default: undefined
        },
        paymentInfoDetail: {
            type: String,
            required: false,
            default: undefined
        },
        linkLabel: {
            type: String,
            required: false,
            default: undefined
        },
        modalId: {
            type: String,
            required: false,
            default: undefined
        },
        isFromMobileDetail: {
            type: Boolean,
            required: false,
            default: false
        }
    }
}
</script>
